export const assets = {
  /** Official promotional asset — "Así es la app por dentro". Never edit or recreate. Used ONCE. */
  appPromo:
    'https://cdn.magicpatterns.com/uploads/ky3BJmCuYqygcZsSfNMv22/ChatGPT_Image_29_ago_2026,_07_53_20_p.m..png',
  /** Official Pawsy Emprende logo. Never edit or recreate. */
  logo:
    'https://cdn.magicpatterns.com/uploads/jViahWZH4fe1yBftKXZscy/ChatGPT_Image_27_ago_2026,_04_02_30_p.m..png',
  /** Official app icon. */
  appIcon:
    'https://cdn.magicpatterns.com/uploads/nezz4AhBzhVqaFbjQd9kUG/ChatGPT_Image_27_ago_2026,_04_58_20_p.m..png',
  /** Hero photo: paseadora cruzando la calle con tres perros pequeños. */
  heroPhoto:
    'https://cdn.magicpatterns.com/uploads/wwrHNHWdPkrR2aYtAZYcuU/Amazing_Dog_Photos_(1).jpg',
  /** Decorativo: hocico con la lengua afuera, asomando desde el borde. */
  dogSnout:
    'https://cdn.magicpatterns.com/uploads/oZgZeo4Mse3vB5fx2gNVVY/descarga__18_-removebg-preview.png',
  /** Decorativo: perrito asomando desde el borde. */
  dogPeeking:
    'https://cdn.magicpatterns.com/uploads/6mFVwKzBXn9XnRNJqxvQwz/descarga__19_-removebg-preview.png',
}

/** Plazo de garantía del producto. Editable en un solo lugar. */
export const guaranteePeriod = '7 días'

/**
 * Fin del precio de lanzamiento (fecha/hora local, formato ISO).
 * Editable: cambiá esta fecha para mover el contador.
 */
export const launchPriceEndsAt = '2026-09-15T23:59:59'

export type Pillar = {
  icon: 'learn' | 'service' | 'clients' | 'organize'
  title: string
  description: string
}

export const pillars: Pillar[] = [
  {
    icon: 'learn',
    title: 'Aprendé',
    description: 'Lo esencial para cuidar y pasear perros.',
  },
  {
    icon: 'service',
    title: 'Armá tu servicio',
    description: 'Definí qué ofrecés, duración y precios.',
  },
  {
    icon: 'clients',
    title: 'Conseguí clientes',
    description: 'Prepará tu perfil y mensajes para empezar a ofrecerte.',
  },
  {
    icon: 'organize',
    title: 'Organizá tu trabajo',
    description: 'Agenda, clientes, mascotas, cobros y tareas.',
  },
]

export const takeaways: string[] = [
  'Servicios definidos',
  'Precios de referencia',
  'Perfil listo para mostrar',
  'Mensajes preparados para contactar clientes',
  'Agenda para organizar tus turnos',
  'Registro de clientes, mascotas e ingresos',
]

export const priceIncludes: string[] = [
  'Acceso completo a Pawsy Emprende',
  'Acceso inmediato después del pago',
  'Sin suscripción mensual',
]

export const afterPaymentSteps: string[] = [
  'Completás el pago.',
  'Recibís el link de acceso en tu email.',
  'Entrás a Pawsy Emprende y empezás.',
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Qué es Pawsy Emprende?',
    answer:
      'Es una app para personas que quieren empezar a ofrecer servicios de cuidado y paseo de mascotas. Adentro aprendés lo esencial, armás tus servicios y precios, preparás tu perfil y organizás tu trabajo.',
  },
  {
    question: '¿Necesito experiencia previa con perros?',
    answer:
      'No. La app arranca desde los primeros pasos y te guía en orden, así podés avanzar a tu ritmo aunque nunca hayas trabajado con mascotas.',
  },
  {
    question: '¿Es un curso?',
    answer:
      'No. Hay contenido para aprender lo esencial, pero es una app: cada paso deja algo armado y guardado, como tus servicios, tu perfil, tu agenda y tus clientes.',
  },
  {
    question: '¿Qué incluye el acceso?',
    answer:
      'Acceso completo a la app: Aprendé, Creá tu servicio, Conseguí clientes y Mi negocio (agenda, clientes y mascotas, ingresos y tareas).',
  },
  {
    question: '¿Tengo que pagar una suscripción mensual?',
    answer: 'No. Es un pago único de $19.990, con opción de 3 cuotas sin interés con Mercado Pago.',
  },
  {
    question: '¿Cómo recibo el acceso después de comprar?',
    answer:
      'Cuando se confirma el pago, recibís el link de acceso en tu email. Con ese link entrás a Pawsy Emprende y empezás.',
  },
  {
    question: '¿Puedo hacerlo desde el celular?',
    answer:
      'Sí. Pawsy Emprende está pensada para usarse desde el celular, y también podés entrar desde una computadora.',
  },
  {
    question: '¿Qué pasa si compro y después cambio de opinión?',
    answer: `Tenés garantía de ${guaranteePeriod}. Escribinos por email dentro de ese plazo y gestionamos la devolución de tu pago.`,
  },
]
